import React from 'react';
import { type EntryPointProps, graphql, usePreloadedQuery, type PreloadedQuery } from 'react-relay';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import type { UserSegmentationRedirectEntryQuery } from './__generated__/UserSegmentationRedirectEntryQuery.graphql';
import UserSegmentationRedirect from './UserSegmentationRedirect.tsx';

type Queries = {
	userSegQueryRef?: PreloadedQuery<UserSegmentationRedirectEntryQuery>;
};

const UserSegmentationRedirectInner = ({
	userSegQueryRef,
}: {
	userSegQueryRef: NonNullable<Queries['userSegQueryRef']>;
}): React.JSX.Element => {
	/**
	 * ⚠️ This is just temporary redirect logic used for testing
	 * while awaiting the implementation of a new query
	 */
	const queryRef = usePreloadedQuery<UserSegmentationRedirectEntryQuery>(
		graphql`
			query UserSegmentationRedirectEntryQuery($accountId: ID!, $cloudId: ID!) @preloadable {
				...UserSegmentationRedirect_fragment
			}
		`,
		userSegQueryRef,
	);

	return (
		<ContextualAnalyticsData sourceType={SCREEN} sourceName="globalRedirect">
			<UserSegmentationRedirect queryRef={queryRef} />
		</ContextualAnalyticsData>
	);
};

const UserSegmentationRedirectEntry = ({
	queries: { userSegQueryRef },
}: EntryPointProps<
	Queries,
	Record<string, never>,
	Record<string, never>,
	Record<string, never>
>): React.JSX.Element | null => {
	if (!userSegQueryRef) {
		return null;
	}

	return <UserSegmentationRedirectInner userSegQueryRef={userSegQueryRef} />;
};

export default UserSegmentationRedirectEntry;
